const Events = require('../util/events');
const DataTable = require('../util/data-table');

var MealItemsManager = function(el, opts) {
    this.$el = el instanceof jQuery ? el : $(el);
    this.options = opts || {};
    this.init();
};
MealItemsManager.prototype = {
    constructor: MealItemsManager,
    $el: undefined,
    options: undefined,
    events: undefined,
    dataTable: undefined,
    currentCategory: undefined,
    init: function() {
        var self = this;
        if (!self.$el.length || self.$el.attr('data-state') == 'loaded') { return; }
        self.$el.attr('data-state', 'loaded');

        self.currentCategory = self.$el.find('table').attr('data-category');
        window.mealItemsManagerQueryParams = function(params) { return self.queryParams(params) };

        // category selection
        var $selection = self.$el.find('.mealitems-select');
        $selection.removeClass('d-none');
        $selection.on('change', function(evt) {
            window.location = evt.target.value;
        });

        self.$el.find('table').on('click', 'tbody a.delete-btn', function(evt) {
            evt.preventDefault();
            self.handleDeleteButton($(evt.currentTarget));
            return false;
        });

        $('#standard-modal').on('click', 'a.delete-btn', function(evt) {
            evt.preventDefault();
            self.requestDeleteButton($(evt.currentTarget));
            return false;
        });

        self.initTable();

        console.log('MealItemsManager::init()');
    },
    initTable: function() {
        var self = this;
        self.dataTable = new DataTable(self.$el.find('table'), {
            height: true,
            autoInit: false
        });
        self.dataTable.events.on('loaded', function() {
            console.log('loaded');
            // self.dataTable.$el.bootstrapTable('sortBy', {field: 'name', sortOrder: 'asc'});
            document.querySelector('th[data-field="name"] div.sortable').click();
        });
        self.dataTable.init();
    },
    queryParams: function(params) {
        params.category = this.currentCategory;
        return params;
    },
    handleDeleteButton: function($link) {
        var self = this,
            href = $link.attr('href');
        $.get(href).done(function(response) {
            var $modal = $('#standard-modal');
            $modal.find('.modal-header h5').html('Delete Meal Item');
            $modal.find('.modal-body').html(response);
            $modal.find('.modal-footer').html(
                '<a href="' + href + '" class="btn btn-danger delete-btn">Delete</a>\
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>'
            );
            var instance = bootstrap.Modal.getOrCreateInstance('#standard-modal');
            instance.show();
        });
    },
    requestDeleteButton: function($link) {
        var self = this,
            href = $link.attr('href');
        $.post(href + '?delete=true', {
            '_token': $link.closest('.modal-content').find('input[type=hidden]').val()
        }).done(function(response) {
            if (response.success) {
                self.dataTable.$el.bootstrapTable('refresh');
                var instance = bootstrap.Modal.getOrCreateInstance('#standard-modal');
                instance.hide();
            }
        });
    }
};

module.exports = MealItemsManager;